import { render, staticRenderFns } from "./ComplaintsTable.vue?vue&type=template&id=17a54d4c&scoped=true&"
import script from "./ComplaintsTable.vue?vue&type=script&lang=js&"
export * from "./ComplaintsTable.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintsTable.vue?vue&type=style&index=0&id=17a54d4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a54d4c",
  null
  
)

export default component.exports